import React, { useState, useEffect } from 'react';
import './QtyControl.css';
import { AssetUrls } from 'config/assets';

interface QtyControlProps {
  defaultValue?: number;
  min?: number;
  max?: number;
  onChange?: (value: number) => void;
}

const QtyControl: React.FC<QtyControlProps> = ({
  defaultValue = 1,
  min = 1,
  max = 99,
  onChange,
}) => {
  const [qty, setQty] = useState(defaultValue);
  
  // Update internal state when defaultValue changes
  useEffect(() => {
    setQty(defaultValue);
  }, [defaultValue]);

  const handleChange = (value: number) => {
    const clampedValue = Math.max(min, Math.min(max, value));
    setQty(clampedValue);
    onChange?.(clampedValue);
  };

  const parseInput = (e: React.ChangeEvent<HTMLInputElement>) =>
    Number(e.target.value.replace(/[^0-9]/g, '')) || min;

  return (
    <div className="qty-control">
      <div className="qty-input-wrapper">
        <div className="qty-arrows">
          <img
            src={AssetUrls.icons.dropdowns.arrowUp}
            alt="up"
            onClick={() => handleChange(qty + 1)}
          />
          <img
            src={AssetUrls.icons.dropdowns.arrowDown}
            alt="down"
            onClick={() => handleChange(qty - 1)}
          />
        </div>
        <input
          type="text"
          value={qty}
          onChange={(e) => handleChange(parseInput(e))}
        />
      </div>
    </div>
  );
};

export default QtyControl;
